export const MESSAGES_ENQUEUE_TOAST_MESSAGE = 'MESSAGES_ENQUEUE_TOAST_MESSAGE';
export const MESSAGES_DEQUEUE_TOAST_MESSAGE = 'MESSAGES_DEQUEUE_TOAST_MESSAGE';
export const MESSAGES_SET_HEADER_MESSAGE = 'MESSAGES_SET_HEADER_MESSAGE';
